module.exports = __webpack_public_path__ + "static/media/ZiXun2.5d964a88.png";